import { Injectable } from '@angular/core';
import { LoadingController } from '@ionic/angular';

@Injectable({ providedIn: 'root' })
export class LoaderService {
    constructor(private loadingController: LoadingController) {}

    async withLoading<T>(message: string, action: () => Promise<T>): Promise<T> {
        const loading = await this.loadingController.create({ message });
        await loading.present();
        try {
            return await action();
        } finally {
            await loading.dismiss();
        }
    }
}